import CONSTANTS from '../constants'
import { EMPTY_OBJECT } from '../../constants/globalConstants'

const INITIAL_STATE = {
	loader: false,
	isAuthenticated: false,
	hasError: false,
	data: EMPTY_OBJECT,
	faclityData: EMPTY_OBJECT,
	email: null,
	role: null,
	errorMessage: '',
	id: null,
	orgId: '',
	endTicketData: EMPTY_OBJECT
}

const transientReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		// get facilty reducer 
		case CONSTANTS.GET_FACILITY_RATE_REQUEST:
			return {
				...state,
				loader: true,
				errorMessage: ''
			}
		case CONSTANTS.GET_FACILITY_RATE_SUCCESS:
			return {
				...state,
				loader: false,
				faclityData: action.data,
				isAuthenticated: true,
				hasError: false,
				errorMessage: ''
			}
		case CONSTANTS.GET_FACILITY_RATE_FAILURE:
			return {
				...state,
				loader: false,
				errorMessage: 'There is some Error'
			}

		// for the payment api 
		case CONSTANTS.POST_CARD_PAYMENT_REQUEST:
			return {
				...state,
				loader: true,
				errorMessage: ''
			}
		case CONSTANTS.POST_CARD_PAYMENT_SUCCESS:
			return {
				...state,
				loader: false,
				faclityData: action.data,
				isAuthenticated: true,
				hasError: false,
				errorMessage: ''
			}
		case CONSTANTS.POST_CARD_PAYMENT_FAILURE:
			return {
				...state,
				loader: false,
				errorMessage: 'There is some Error'
			}

		// End Parking
		case CONSTANTS.END_PARKING_REQUEST:
			return {
				...state,
				loader: true,
				errorMessage: ''
			}
		case CONSTANTS.END_PARKING_SUCCESS:
			return {
				...state,
				loader: false,
				endTicketData: action.data,
				hasError: false,
				errorMessage: ''
			}
		case CONSTANTS.END_PARKING_FAILURE:
			return {
				...state,
				loader: false,
				hasError: true,
				errorMessage: 'There is some Error'
			}
		// End Parking
		case CONSTANTS.FACILITY_ON_MARKER_REQUEST:
			return {
				...state,
				loader: true,
				errorMessage: ''
			}
		case CONSTANTS.FACILITY_ON_MARKER_SUCCESS:
			return {
				...state,
				loader: false,
				// endTicketData: action.data,
				hasError: false,
				errorMessage: ''
			}
		case CONSTANTS.FACILITY_ON_MARKER_FAILURE:
			return {
				...state,
				loader: false,
				hasError: true,
				errorMessage: 'There is some Error'
			}

		// Reservation ID
		case CONSTANTS.PROMOCODE_REQUEST:
			return {
				...state,
				loader: true,
				errorMessage: ''
			}
		case CONSTANTS.PROMOCODE_SUCCESS:
			return {
				...state,
				loader: false,
				// endTicketData: action.data,
				hasError: false,
				errorMessage: ''
			}
		case CONSTANTS.PROMOCODE_FAILURE:
			return {
				...state,
				loader: false,
				hasError: true,
				errorMessage: 'There is some Error'
			}
		default:
			return state
	}
}

export default transientReducer
